export function loggedIn() {
  if (localStorage.getItem('jwtToken')) {
    return true
  } else {
    return false
  }
}